import { WarningImage } from '@approvalmax/ui';
import { Button, Flex, Grid, Popup, Text } from '@approvalmax/ui/src/components';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';
import { getPath, Path } from 'urlBuilder';

import { messages } from './ReconnectOrgPopup.messages';
import { reconnectOrgPopupOpenState } from './ReconnectOrgPopup.states';
import { LogoWrapper, StyledXeroLogo } from './ReconnectOrgPopup.styles';

export const ReconnectOrgPopup = () => {
    const company = useCompanyBasedOnUrl();
    const [open, toggleOpen] = useAtom(reconnectOrgPopupOpenState);

    const handleDoItLater = useCallback(() => {
        toggleOpen(false);
    }, [toggleOpen]);

    return (
        <Popup size='xsmall' open={open} onToggle={toggleOpen}>
            <Popup.Header />

            <Popup.Body spacing='32'>
                <Grid gap={24} justifyItems='center'>
                    <LogoWrapper>
                        <WarningImage />

                        <StyledXeroLogo size={32} />
                    </LogoWrapper>

                    <Text font='headline' fontSize='small' fontWeight='medium' color='midnight80' textAlign='center'>
                        {messages.xeroDoesntGrant}
                    </Text>

                    <Text font='body' fontSize='medium' color='midnight100' textAlign='center'>
                        {messages.toProceed}
                    </Text>

                    <Text font='label' fontSize='medium'>
                        {messages.learnMore}
                    </Text>

                    <Flex spacing='24'>
                        <Button variant='outline' color='midnight80' size='large' onClick={handleDoItLater}>
                            {messages.doItLater}
                        </Button>

                        <Button as={Link} color='blue80' size='large' to={getPath(Path.companyInfo, company.id)}>
                            {messages.reconnectOrg}
                        </Button>
                    </Flex>
                </Grid>
            </Popup.Body>
        </Popup>
    );
};
